var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex teacher-board"},[_vm._v(" 今年完课: "+_vm._s(_vm.info.done_course)+"天 待实施："+_vm._s(_vm.info.wait_course)+"天 预约： "+_vm._s(_vm.info.app_course)+" 天 ")])}
var staticRenderFns = []

export { render, staticRenderFns }